export var getFooterParts = function getFooterParts(title) {
  var array = (title || '').split(' ');
  var length = array.length;
  var firstPart = array.slice(0, length - 1);
  var firstPartHtml = firstPart.length ? firstPart.join(' ') : undefined;
  return {
    titleFirstPart: firstPartHtml,
    titleSecondPart: array[length - 1] || undefined
  };
};